<template>
  <el-dialog
    title="Configure Content Refresh"
    :visible.sync="dialogVisible"
    width="700px"
    :before-close="handleClose"
  >
    <div>
      <p><strong>Website:</strong> {{ website.title }}</p>

      <!-- Enable/Disable -->
      <div style="display: flex; align-items: center; gap: 10px">
        <p><strong>Enable:</strong></p>
        <el-switch v-model="enabled" />
      </div>

      <div class="mb-4">
        <p><strong>Frequency:</strong></p>
        <el-radio-group v-model="frequency" style="width: 100%; display: flex; gap: 10px">
          <el-radio label="Daily">Daily</el-radio>
          <el-radio label="Weekly">Weekly</el-radio>
          <el-radio label="Monthly">Monthly</el-radio>
          <el-radio label="Custom">Custom</el-radio>
        </el-radio-group>
      </div>

      <div class="mb-4">
        <p><strong>Time:</strong></p>
        <el-time-picker
          v-model="time"
          placeholder="Select time"
          format="hh:mm A"
          value-format="HH:mm:ss"
        />
      </div>

      <div class="mb-4" v-if="frequency === 'Weekly'">
        <p><strong>Days:</strong></p>
        <el-button-group>
          <el-button
            v-for="day in days"
            :key="day"
            :type="selectedDays.includes(day) ? 'primary' : 'default'"
            @click="toggleDay(day)"
          >
            {{ day }}
          </el-button>
        </el-button-group>
      </div>

      <div class="mb-4" v-if="frequency === 'Monthly'">
        <p><strong>Day of the Month:</strong></p>
        <el-select v-model="dayOfMonth" placeholder="Select day" style="width: 120px">
          <el-option v-for="n in 31" :key="n" :label="n" :value="n" />
        </el-select>
      </div>
    </div>

    <div class="mb-4" v-if="frequency === 'Custom'">
      <p><strong>Choose Specific Date:</strong></p>
      <el-date-picker
        v-model="customDate"
        type="date"
        placeholder="Pick a date"
        :picker-options="{
          disabledDate(time) {
            return time.getTime() < Date.now() - 86400000;
          },
        }"
      />
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">Cancel</el-button>
      <el-button type="primary" @click="saveSchedule">Save Schedule</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    website: {
      type: Object,
      required: true,
    },
    dialogVisible: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      enabled: true,
      frequency: "Daily",
      time: "09:00:00",
      days: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      selectedDays: [],
      dayOfMonth: 1,
      customDate: null,
    };
  },
  methods: {
    toggleDay(day) {
      if (this.selectedDays.includes(day)) {
        this.selectedDays = this.selectedDays.filter((d) => d !== day);
      } else {
        this.selectedDays.push(day);
      }
    },
    handleClose() {
      this.$emit("updateDialogVisible", false);
    },
    saveSchedule() {
      const updatedWebsite = {
        ...this.website,
        scheduleEnabled: this.enabled,
        schedule: JSON.stringify({
          frequency: this.frequency,
          time: this.time,
          selectedDays: this.selectedDays,
          dayOfMonth: this.dayOfMonth,
          customDate: this.customDate,
        }),
        tags: JSON.stringify(this.website.tags),
      };
      this.$emit("saveSchedule", updatedWebsite);
      this.handleClose();
    },
  },
  mounted() {
    this.enabled = this.website.scheduleEnabled;
    const schedule = this.website.schedule ? JSON.parse(this.website.schedule) : null;

    if (schedule) {
      const { frequency, time, selectedDays, dayOfMonth, customDate } = schedule;
      this.frequency = frequency;
      this.time = time;
      this.selectedDays = selectedDays;
      this.dayOfMonth = dayOfMonth;
      this.customDate = customDate;
    }
  },
};
</script>

<style scoped>
.mb-4 {
  margin-bottom: 1rem;
}
</style>
